import { BpkButtonLink } from '@skyscanner/backpack-web/bpk-component-link';
import BpkText from '@skyscanner/backpack-web/bpk-component-text';

import BpkLoadingButton from '../../../common/BpkLoadingButton';
import { withI18n } from '../../../contexts/i18n';
import GoogleTranslationLogo from '../../GoogleTranslationLogo';

import type { I18nService } from '@shared/types/i18n';
import type { Maybe } from '@shared/types/utils';

import STYLES from './TranslationButton.module.scss';

import { TranslationState } from '@shared/utils-frontend/translate-state';

type Props = {
  i18n: I18nService;
  onTranslate?: Maybe<Function>;
  translationState?: keyof typeof TranslationState;
  translationType?: string;
  translated?: boolean;
};

const TranslationButton = ({
  i18n,
  onTranslate,
  translated,
  translationState,
  translationType,
}: Props) => {
  const googleTranslationLogo = (
    <GoogleTranslationLogo className={STYLES.TranslationButton__googleLogo} />
  );
  let translationButton = null;
  let translatedBy = null;

  if (translated && translationType === 'TRANSLATION_TYPE_TRANSLATED') {
    translatedBy = googleTranslationLogo;
  }

  if (translationState === TranslationState.PENDING) {
    translationButton = (
      <BpkLoadingButton link loading disabled onClick={onTranslate}>
        {i18n.translate('hotel_review_view_translation')}
      </BpkLoadingButton>
    );
  } else if (translationState === TranslationState.TRANSLATED) {
    translationButton = (
      <BpkButtonLink
        onClick={(e: Event) => {
          e.stopPropagation();
          if (onTranslate) {
            onTranslate();
          }
        }}
      >
        {i18n.translate('hotel_review_view_original')}
      </BpkButtonLink>
    );
    translatedBy = googleTranslationLogo;
  } else if (onTranslate && !translated) {
    translationButton = (
      <BpkButtonLink
        onClick={(e: Event) => {
          e.stopPropagation();
          onTranslate();
        }}
        elementName="description_view_translation_button"
      >
        {i18n.translate('hotel_review_view_translation')}
      </BpkButtonLink>
    );
  }

  if (!translatedBy && !translationButton) {
    return null;
  }

  return (
    <div className={STYLES.TranslationButton}>
      {translatedBy}
      {translatedBy && translationButton ? (
        <BpkText className={STYLES.TranslationButton__translatedBy}>|</BpkText>
      ) : null}
      {translationButton && (
        <div className={STYLES.TranslationButton__btnWrap}>
          {translationButton}
        </div>
      )}
    </div>
  );
};

export default withI18n(TranslationButton);
